import { cn } from "../../../utils/class-names";
import { KeyValueList } from "../../key-value-list";
import { asPercent, getCollateralAprMetrics } from "@silo/utils";
import { BreakdownCollateral } from "../breakdown/breakdown-collateral";
import { CollateralAprAsset, Percent } from "@silo/types";

export interface PositionCollateralProps {
  className?: string;
  asset: CollateralAprAsset;
  nativeRewardsSymbol: string;
}

export function PositionCollateral({
  className,
  asset,
  nativeRewardsSymbol,
}: PositionCollateralProps): JSX.Element {
  const { collateralBaseApr } = asset;

  const { hasCollateralRewards, totalCollateralApr, collateralRewards } =
    getCollateralAprMetrics(asset, nativeRewardsSymbol);

  return (
    <div className={cn("flex flex-col", className)}>
      <KeyValueList.Pair>
        <KeyValueList.Key>APR</KeyValueList.Key>

        <KeyValueList.Value
          dataCy="apy"
          className={cn(
            "font-mono font-medium",
            hasCollateralRewards ? "text-amber-300" : "text-white"
          )}
        >
          {asPercent(totalCollateralApr)}
        </KeyValueList.Value>
      </KeyValueList.Pair>

      {hasCollateralRewards && (
        <BreakdownCollateral
          className="gap-0 text-sm"
          align="right"
          collateralBaseApr={collateralBaseApr}
          collateralRewards={collateralRewards}
        />
      )}
    </div>
  );
}
